module.exports = __webpack_public_path__ + "img/ms.ms0c0db89.svg";